import { mergeStyleSets, useTheme } from "@fluentui/react";

export const useStyles = () => {
  const theme = useTheme();

  return mergeStyleSets({
    fieldListItem: {
      cursor: 'pointer',
      display: 'flex',
      gap: '4px',
      boxSizing: 'border-box',
      padding: '6px 18px',
      '&:hover': {
        backgroundColor: theme.palette.neutralLighterAlt,
      }
    }
  })
}
